import React from "react";
import { Colors } from "../../design/Colors";
export default class Header extends React.Component{

    render(){
        return <div style={{display:"flex",backgroundColor:Colors.grey, height:'9.8vh', flexDirection:"row",justifyContent:'center'}}>
            <text style={{textAlign:'center',alignSelf:'center'}}> © 2023 CBW Bank Inc. All Rights Reserved.</text>
        </div>
    }
}